import { useAsync } from '@nxsys/hooks/useAsync';
import {
  getAWRListApi,
  getFiftyTwoWeekAverageSummaryListApi,
  getHolidayPayBalanceSummaryListApi,
  getHolidayPayListApi,
  getNetPayListApi,
  getRTWListApi,
  getWTRListApi,
} from '@nxsys/services/api/holidayPay';
import {
  GetAWRListParams,
  GetAWRListResponse,
  GetFiftyTwoWeekAverageSummaryListParams,
  GetFiftyTwoWeekAverageSummaryListResponse,
  GetHolidayPayBalanceDetailListParams,
  GetHolidayPayBalanceDetailListResponse,
  GetHolidayPayBalanceSummaryListParams,
  GetHolidayPayBalanceSummaryListResponse,
  GetNetPayListParams,
  GetNetPayListResponse,
  GetRTWListParams,
  GetRTWListResponse,
  GetWTRListParams,
  GetWTRListResponse,
} from '@nxsys/store/slices/report/types';
import { showMessage } from '@nxsys/utils/message';
import { useEffect } from 'react';
import { getErrorMessage } from '@nxsys/utils/getErrorMessage';

export const useGetHolidayPayList = () => {
  const { value, loading, error, run } = useAsync<
    GetHolidayPayBalanceDetailListResponse,
    GetHolidayPayBalanceDetailListParams
  >(getHolidayPayListApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetHolidayPayBalanceSummaryList = () => {
  const { value, loading, error, run } = useAsync<
    GetHolidayPayBalanceSummaryListResponse,
    GetHolidayPayBalanceSummaryListParams
  >(getHolidayPayBalanceSummaryListApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetNetPayList = () => {
  const { value, loading, error, run } = useAsync<
    GetNetPayListResponse,
    GetNetPayListParams
  >(getNetPayListApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetFiftyTwoWeekAverageSummaryList = () => {
  const { value, loading, error, run } = useAsync<
    GetFiftyTwoWeekAverageSummaryListResponse,
    GetFiftyTwoWeekAverageSummaryListParams
  >(getFiftyTwoWeekAverageSummaryListApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetRTWList = () => {
  const { value, loading, error, run } = useAsync<
    GetRTWListResponse,
    GetRTWListParams
  >(getRTWListApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetAWRList = () => {
  const { value, loading, error, run } = useAsync<
    GetAWRListResponse,
    GetAWRListParams
  >(getAWRListApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetWTRList = () => {
  const { value, loading, error, run } = useAsync<
    GetWTRListResponse,
    GetWTRListParams
  >(getWTRListApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};
